var Otto = Otto || {};

/**
 * FAQ module for expand/collapse behavior
 */
Otto.faq = (function(my, $) {
    var exports = {},
        isInit = false;

    function wireEvents() {
        $('.faq').on('click', '.faq__icon, .faq__question', function(evt){
            evt.preventDefault();
            closeOthers(evt.currentTarget);
            toggleIt(evt.currentTarget);
        });
    }

    function closeOthers(clickedEl) {
        var item = $(clickedEl).closest('.faq__item');
        $('.faq__item').each(function(index, el) {
            var $el = $(el);
            if (($el[0] != $(item)[0]) && $el.hasClass('faq__item--is-active')) {
                $el.removeClass('faq__item--is-active');
                $el.find('.faq__answer').slideUp();
            }
        });
    }

    function toggleIt(clickedEl) {
        var item = $(clickedEl).closest('.faq__item');
        $(item).toggleClass('faq__item--is-active');
        if ($(item).hasClass('faq__item--is-active')) {
            $(item).find('.faq__answer').slideDown();
        } else {
            $(item).find('.faq__answer').slideUp();
        }
    }

    exports.init = function() {
        if (isInit) {
            return;
        }
        isInit = true;

        $('.faq').find('.faq__answer').hide();
        wireEvents();
    };

    return exports;
})(Otto, jQuery);
